import React, { useMemo, useState } from 'react';
import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  IconButton,
} from '@mui/material';
import styles from './refundPaymentRequest.module.scss';
import { GenericTable } from 'components/common/GenericTable';
import { EARLY_PAY_REQUEST_COLUMNS } from 'utils/requests';
import { Close } from '@mui/icons-material';
import { refundPaymentActions } from '_redux/slices/refundPayment.slice';
import { useDispatch, useSelector } from 'react-redux';
import { formatDate } from 'utils';
import { REFUND_PAYMENT_ADMIN_VERIFICATION } from '_redux/types/refundpayments.types';

const RefundPaymentRequest = ({ handleClose }) => {
  const [adminNote, setAdminNote] = useState('');
  const selectedRefundPayment = useSelector(
    refundPaymentActions.selectors.getSelectedRefundPayment
  );
  const dispatch = useDispatch();

  const refundPayment = selectedRefundPayment?.RefundPayment || {};
  const employeeHistory = selectedRefundPayment?.employeeHistory || [];

  const formattedRequestDate = useMemo(
    () => formatDate(refundPayment.requestDate),
    [refundPayment.requestDate]
  );

  const handleApproval = status => {
    dispatch({
      type: REFUND_PAYMENT_ADMIN_VERIFICATION,
      payload: { id: refundPayment?.id, status: status, note: adminNote },
    });
    handleClose();
  };

  return (
    <Box className={styles.earlyPaymentContainer}>
      <Box className={styles.heading}>
        <Typography variant="h6" className={styles.title}>
          Refund Request
        </Typography>
        <IconButton onClick={handleClose} className={styles.closeButton}>
          <Close />
        </IconButton>
      </Box>

      <Box className={styles.formContainer}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Advisor Name"
              variant="outlined"
              value={refundPayment?.employeeName || ''}
              className={styles.textField}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Advisors ID"
              variant="outlined"
              value={refundPayment?.employeeId || ''}
              className={styles.textField}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Total Commission Earned"
              variant="outlined"
              value={refundPayment.totalCommission || ''}
              className={styles.textField}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Reason For Refund"
              variant="outlined"
              value={refundPayment.reason || ''}
              className={styles.textField}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Request Date"
              variant="outlined"
              value={formattedRequestDate || ''}
              className={styles.textField}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={4}
              label="Admin Note"
              variant="outlined"
              value={adminNote || refundPayment?.note}
              onChange={e => setAdminNote(e.target.value)}
              className={styles.textField}
            />
          </Grid>
        </Grid>

        <Box className={styles.tableContainer}>
          <Typography variant="h6" className={styles.tableTitle}>
            Request History
          </Typography>
          <GenericTable
            title=""
            data={employeeHistory}
            columns={EARLY_PAY_REQUEST_COLUMNS}
            pageConfig={{
              page: 0,
              setPage: () => {},
              rowsPerPage: 10,
              setRowsPerPage: () => {},
            }}
            isTabs={false}
            isSearch={false}
            isPagination={false}
          />
        </Box>

        <Box className={styles.actionButtons}>
          <Button
            variant="outlined"
            className={styles.rejectButton}
            onClick={() => handleApproval('Rejected')}
          >
            Reject
          </Button>
          <Button
            variant="contained"
            className={styles.acceptButton}
            onClick={() => handleApproval('Approved')}
          >
            Accept
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default RefundPaymentRequest;
